import type { TrainingLessonSpecific } from './trainingLessonUi';

export const core3PriesthoodEn: TrainingLessonSpecific = {
  intro:
    'The priesthood is God’s power and authority to act in His name. In this lesson you will explore the difference between authority and power, the meaning of keys, and how priesthood is exercised through service and righteousness.',
  objectives: [
    'Understand what the priesthood is and why it exists.',
    'Differentiate priesthood authority vs priesthood power.',
    'Differentiate priesthood keys vs delegated authority.',
    'Understand the difference and purpose of the Aaronic and Melchizedek Priesthoods.',
    'Identify practical habits to exercise the priesthood with dignity and reverence.',
  ],
  briefHeading: 'The priesthood: authority, keys, and service',
  briefBody:
    'Priesthood authority is the right to act in God’s name; power depends on righteousness, faith, humility, and obedience. Keys are the right to preside and direct how authority is used in an area. The Aaronic Priesthood focuses on preparatory ordinances and ministry; the Melchizedek Priesthood on spiritual ordinances and governing the Church. Both are exercised through service and dignity. For Church organization and duties, study the General Handbook (section 3) on ChurchofJesusChrist.org.',
  scriptures: [
    {
      ref: 'D&C 13',
      text: 'Upon you my fellow servants, in the name of Messiah, I confer the Priesthood of Aaron...',
    },
    {
      ref: 'D&C 20:38–60',
      text: 'Offices and duties: baptism, sacrament, blessings, and ordinances.',
    },
    {
      ref: 'D&C 107:1–20',
      text: 'There are, in the church, two priesthoods, namely, the Melchizedek and Aaronic...',
    },
    {
      ref: 'Matthew 16:19',
      text: 'And I will give unto thee the keys of the kingdom of heaven...',
    },
    {
      ref: 'Hebrews 5:4',
      text: 'And no man taketh this honour unto himself, but he that is called of God...',
    },
  ],
  didYouKnow: [
    'Keys are not “more power”: they are the right to preside and direct how priesthood authority is used in an area (ward, stake, ordinances).',
    'Priesthood power does not “turn on” because of a calling: it shows through righteousness, faith, humility, and obedience. Authority may be present; power depends on the heart.',
  ],
  practiceItems: [
    'Explain in your own words the difference between priesthood authority and power (1–2 lines)',
    'Explain in your own words what priesthood keys are (1–2 lines)',
    'Identify who presides with keys in your ward (bishop / stake president) and why',
    'Before sacrament, do simple preparation: prayer + review conduct + reverence',
    'Practice reverence: arrive 10 minutes early and sit ready without distractions (one Sunday)',
    'Choose one quiet act of service this week (without announcing or posting it)',
  ],
  reflectionQuestions: [
    'In what area of my life do I need more priesthood power (more faith and obedience), even if I already have authority or access to ordinances?',
    'What is hardest for me to understand: keys, offices, or dignity? Why?',
    'What will I do differently this Sunday to honor the priesthood and the sacrament?',
  ],
  actionText:
    'Sunday preparation: this week pick one concrete thing to arrive more prepared (e.g., lay out clothes, sleep earlier, read one scripture, seek forgiveness, silence your phone in the meeting).',
};
